import { ChangeDetectorRef, Injectable, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { ForuscareService } from '../../services/foruscare/foruscare.service';
import { SharedService } from '../../services/shared/shared.service';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class NgIdleService {

  idleState = "NOT_STARTED";
  countdown: number = null;
  warningtimeout: number = 5; /*time in seconds */
  timeout : number = null; /*time in seconds */
  lastPing: Date = null;
  constructor(private idle: Idle,
              //private cd:ChangeDetectorRef,
              private sharedService:SharedService,
              private apptitle:Title,
              private foruscareService:ForuscareService) {
    /* set timeout from service file */
    this.timeout = this.foruscareService.IDLE_TIMEOUT;
    /* set idle parameters */
    idle.setIdle(1); /* how long can they be inactive before considered idle, in seconds*/
    idle.setTimeout(this.timeout); /* how long can they be idle before considered timed out, in seconds*/
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); /* provide sources that will "interrupt" aka provide events indicating the user is active*/

    /* do something when the user is no longer idle */
    idle.onIdleEnd.subscribe(() => {
      this.idleState = "NOT_IDLE";
      /*console.log(`${this.idleState} ${new Date()}`);*/
      this.countdown = null;
      //cd.detectChanges(); /* how do i avoid this kludge? */
    });

     /* do something when the user has timed out */
     idle.onTimeout.subscribe(() => {
       this.idleState = "TIMED_OUT"; 
       /* logout*/
       if(this.sharedService != null && this.sharedService.getAccessToken()!=null && this.sharedService.getAccessToken().length>0){
        this.sharedService.logout();
       } 
     });
     /* do something as the timeout countdown does its thing*/
     idle.onTimeoutWarning.subscribe(seconds => {
       this.countdown = seconds;
       if(this.sharedService !=null && this.sharedService.getAccessToken()!=null && this.sharedService.getAccessToken().length>0){
        this.apptitle.setTitle(this.getRemainingTime(this.countdown)+" Forus Account Management");
          if(this.countdown == this.warningtimeout){
            //this.foruscareService.showNotification("Due to inactivity, you will be logged out in "+this.warningtimeout+" seconds","warning")
          }
      }
     });
  }

  reset() {
    /* we'll call this method when we want to start/reset the idle process
      reset any component state and be sure to call idle.watch() */
    this.idle.watch();
    this.idleState = "NOT_IDLE";
    this.countdown = null;
    this.lastPing = null;
  }

  getRemainingTime(seconds:number){
    let min = null;
    let sec = null;
    min = Math.floor(seconds/60);
    min = min<10?('0'+min):min;
    sec = seconds%60;
    sec = sec<10?('0'+sec):sec;
    return min+":"+sec;
  }
  // ngOnInit(): void {
  //    /*right when the component initializes, start reset state and start watching*/
  //   this.reset();
  // }
}
